import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PaginaInicio.css";
import "./TeacherContent.css";
import Cabecera from "../Others/Cabecera";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import PiePagina from "../Others/PiePagina";
import { showContent, downlodContent } from "./constants";
import { useData } from "./DataContext";

const barra_inferior = <BarraInferior />;

const fileType = (file) => (file.tipo_archivo || file.nombre_archivo?.split(".").pop() || "archivo").toUpperCase();

export const MonitorContent = () => {
  const { dataClase } = useData();
  const [archivos, setArchivos] = useState([]);
  const [status, setStatus] = useState({ type: "loading", text: "Cargando contenido..." });
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    if (!dataClase?.matricula_clase) {
      setStatus({ type: "error", text: "Selecciona una clase para consultar su contenido." });
      return;
    }
    const obtenerContenido = async () => {
      try {
        setStatus({ type: "loading", text: "Cargando contenido..." });
        const response = await axios.get(showContent, { params: { matricula: dataClase.matricula_clase } });
        setArchivos(Array.isArray(response.data) ? response.data : []);
        setStatus({ type: "", text: "" });
      } catch (error) {
        console.error("Error al obtener el contenido:", error);
        setStatus({ type: "error", text: "No se pudo cargar el contenido de la clase." });
      }
    };
    obtenerContenido();
  }, [dataClase?.matricula_clase]);

  const descargarContenido = async (archivo) => {
    try {
      setDownloadingId(archivo.id_archivo);
      const response = await axios.get(`${downlodContent}?id_archivo=${archivo.id_archivo}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = archivo.nombre_archivo;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar contenido:", error);
      setStatus({ type: "error", text: "No se pudo descargar el archivo. Intenta nuevamente." });
    } finally {
      setDownloadingId(null);
    }
  };

  const barra_superior = <BarraSuperior texto_cabecera={dataClase?.nombre_clase || "Contenido"} />;

  return (
    <div className="contenedor-pagina">
      <Cabecera contenidosuperior={barra_superior} contenidoInferior={barra_inferior} />
      <main className="course-content-page">
        <section className="course-content-hero">
          <div>
            <span className="course-content-eyebrow">Recursos de la clase</span>
            <h1>Contenido</h1>
            <p>Consulta y descarga los documentos compartidos en este curso.</p>
          </div>
          <div className="course-content-count">{archivos.length} {archivos.length === 1 ? "archivo" : "archivos"}</div>
        </section>

        {status.text && <div className={`course-content-status course-content-status-${status.type}`} role="status">{status.text}</div>}

        {!status.text && archivos.length === 0 ? (
          <section className="course-content-empty">
            <span aria-hidden="true">DOC</span>
            <h2>Aún no hay contenido</h2>
            <p>Los archivos que comparta tu profesor aparecerán aquí.</p>
          </section>
        ) : (
          <section className="course-content-grid" aria-label="Archivos del curso">
            {archivos.map((archivo, index) => (
              <article className="course-file-card" key={archivo.id_archivo || index}>
                <div className="course-file-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24"><path d="M6 2h8l4 4v16H6z"/><path d="M14 2v5h5"/></svg>
                </div>
                <div className="course-file-info">
                  <span>{fileType(archivo)}</span>
                  <h2 title={archivo.nombre_archivo}>{archivo.nombre_archivo}</h2>
                </div>
                <button type="button" className="course-file-download" onClick={() => descargarContenido(archivo)} disabled={downloadingId === archivo.id_archivo}>
                  {downloadingId === archivo.id_archivo ? "Descargando..." : "Descargar"}
                </button>
              </article>
            ))}
          </section>
        )}
      </main>
      <PiePagina imagenSrc={require("../Assets/piepagina.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};
